import moment, { Moment } from 'moment';

export type FinanceDateRange = 'cm' | 'lm' | 'cq' | 'lq' | '30' | '90' | '180' | '365';

export type FinanceDealStatus = 'PIPELINE' | 'CLOSED_WON' | 'ALL';

export type FinancePaymentType = 'ALL' | 'FINANCING' | 'CASH' | 'CREDIT_LINE';

export interface SharedFinanceFilters {
  dateRange: FinanceDateRange;
  dealStatus: FinanceDealStatus;
  paymentType: FinancePaymentType;
}

export const INITIAL_SHARED_FINANCE_FILTERS: SharedFinanceFilters = {
  dateRange: 'cm',
  dealStatus: 'ALL',
  paymentType: 'ALL',
};

/** Converts a PerformanceDateRange preset to the corresponding Moment from/to range. */
export function dateRangeToMoments(range: FinanceDateRange): { from: Moment; to: Moment } {
  switch (range) {
    case 'cm':
      return { from: moment().startOf('month'), to: moment().endOf('month') };
    case 'lm':
      return {
        from: moment().subtract(1, 'month').startOf('month'),
        to: moment().subtract(1, 'month').endOf('month'),
      };
    case 'cq':
      return { from: moment().startOf('quarter'), to: moment().endOf('quarter') };
    case 'lq':
      return {
        from: moment().subtract(1, 'quarter').startOf('quarter'),
        to: moment().subtract(1, 'quarter').endOf('quarter'),
      };
    case '30':
      return { from: moment().subtract(30, 'days').startOf('day'), to: moment().endOf('day') };
    case '90':
      return { from: moment().subtract(90, 'days').startOf('day'), to: moment().endOf('day') };
    case '180':
      return { from: moment().subtract(180, 'days').startOf('day'), to: moment().endOf('day') };
    case '365':
      return { from: moment().subtract(365, 'days').startOf('day'), to: moment().endOf('day') };
  }
}
